import React, { useContext } from "react";

import { GuidelinesItem, FileAttachment } from "./Components";

import {
  BlockIcon,
  DocumentIcon,
  DocumentPDFIcon,
  CloudUploadIcon,
} from "../Common/Svg";

import { Title, Text } from "./../../StyledComponents";

import OrderSummaryMobile from "./../Common/OrderSummary/OrderSummaryMobile";
import OrderSummaryWeb from "./../Common/OrderSummary/OrderSummaryWeb";
import NewCustomerBack from "./../Common/NewCustomerBack/NewCustomerBack";

import { SalesContext } from "../../Context/SalesContext";
import { addBeforeloadEvent, getFileNameWithoutExtension, removeBeforeloadEvent } from "./../../Utility/utility";
import {
  tagOnUploadPageLoadId,
  tagOnUploadPageLoadPassport
} from "../../Tagging/NewCustomerTagging";

import "./UploadDocuments.css";

export default (props) => {
  const context = useContext(SalesContext);

  const [isFormValid, setIsFormValid] = React.useState(false);
  const [currentFileNames, setCurrentFileNames] = React.useState([]);

  React.useEffect(() => {
    const isSaWorkValid =
      context?.employmentDetails?.selectedIdTab === "passportNumber"
        ? context.fileUploadSaWorkPermit
        : true;

    setIsFormValid(
      context.fileUploadId && isSaWorkValid
    );

    const newFileNames = [];
    context.fileUploadId &&
      newFileNames.push(
        getFileNameWithoutExtension(context.fileUploadId.name).trim()
      );
    context.fileUploadSaWorkPermit &&
      newFileNames.push(
        getFileNameWithoutExtension(context.fileUploadSaWorkPermit.name).trim()
      );

    setCurrentFileNames(newFileNames);
  }, [
    context.fileUploadId,
    context.fileUploadSaWorkPermit,
  ]);

  React.useEffect(() => {
    window.scrollTo(0, 0);
    context?.employmentDetails?.selectedIdTab === "passportNumber" ? tagOnUploadPageLoadPassport() : tagOnUploadPageLoadId();
    addBeforeloadEvent();
    return () => {
      removeBeforeloadEvent();
    };
  }, []);

  return (
    <React.Fragment>
      <NewCustomerBack
        title="Back to Credit vetting"
        backUrl="/cloud/fibre/sales/credit-vetting"
      />
      <div className="upload-documents">
        <div className="header-container">
          <div className="content">
            <Title className="upload-documents__web-only">
              Upload Documents
            </Title>
            <Text style={{ padding: "1rem 0" }}>
              All listed documents must be uploaded.
            </Text>
            <FileAttachment
              fileObj={context.fileUploadId}
              onChange={context.setFileUploadId}
              title={"Copy of your ID"}
              file={ context.employmentDetails.selectedIdTab === 'idNumber' ? `idProof${context.employmentDetails.idNumber}` : `idProof${context.employmentDetails.passportNumber}` }
              currentFileNames={currentFileNames}
            />
            {context?.employmentDetails?.selectedIdTab === "passportNumber" && (
              <FileAttachment
                fileObj={context.fileUploadSaWorkPermit}
                onChange={context.setFileUploadSaWorkPermit}
                title={"SA work permit"}
                file={ 'workPermitProof' }
                currentFileNames={currentFileNames}
              />
            )}
          </div>
          <OrderSummaryWeb
            isEnabled={isFormValid}
            submitRoute="/cloud/fibre/sales/review-order"
            page="new customer upload documents"
          />
        </div>
        <div className="guidelines">
          <Title
            style={{
              fontWeight: "700",
            }}
          >
            Documents guidelines
          </Title>
          <Text style={{ padding: "1.5rem 0" }}>
            Please read through the following instructions before uploading your
            files:
          </Text>
          <GuidelinesItem
            icon={DocumentPDFIcon}
            title={"Only certain file formats are accepted."}
            message={
              "Documents can be uploaded if they're saved as pdf, xfdl, jpeg, tiff, jpg or bmp."
            }
          />
          <div className="divider" automationid="SalesLead_Div_Divider_2"/>
          <GuidelinesItem
            icon={CloudUploadIcon}
            title={"The file size is limited to 4MB"}
            message={"Make sure that your files are smaller than 4MB."}
          />
        </div>

        <OrderSummaryMobile
          isEnabled={isFormValid}
          submitRoute="/cloud/fibre/sales/review-order"
          page="new customer upload documents"
        />
      </div>
    </React.Fragment>
  );
};
